export default __webpack_public_path__ + "static/media/author-page-image2.26349de6.PNG";